import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { environment } from '../../../../environments/environment';
import { ONBOARD_CONSTANTS } from '../../../app.constants';
import { AppService } from '../../../app.service';
import { HttpService } from '../../../services/http.service';
import { ErrorService } from '../../error/error.service';
import { BuywifiService } from '../../../services/buywifi.service';

@Injectable()
export class PaymentConfirmationService {
    constructor(private httpService: HttpService,
        private appService: AppService,
        private errorService: ErrorService,
        private buywifiService: BuywifiService) {

    }

    doOrderCall(sessionId: string, offerId: string, noOfKeys: string) {
        let orderCallRequest;
        orderCallRequest = this.formOrderCallRequest(sessionId, offerId, noOfKeys);
        return this.httpService.postData(orderCallRequest).map(
            reserveCallResponse => {
                this.appService.hideLoaderWithText();
                return reserveCallResponse;
            },
            (error: any) => {
                this.errorService.addError(this.buywifiService.getDefaultError());
                this.appService.hideLoaderWithText();
                return error;
            }
        );
    }

    formOrderCallRequest(sessionId, offerId, noOfKeys) {
        const reserveRequest = {
            url: environment.apiBaseUrl + ONBOARD_CONSTANTS.ORDER_POINTS,
            data: {
                'offerId': offerId,
                'keys': noOfKeys,
                'passengerInformation': {
                    'sessionId': sessionId,
                }
            }
        }
        const old = JSON.stringify(reserveRequest);        
        return JSON.parse(old);
    }
}